import * as d3 from "d3";
import $ from "jquery";
import html2canvas from "html2canvas";
import {_} from 'vue-underscore';
import escapeStringRegexp from 'escape-string-regexp';


export function toggleClass(elementClass, toggleClass) {
    const element = document.getElementsByClassName(`${elementClass}`);
    element.classList.toggle(`${toggleClass}`);
}

export function sort_numeric_string_asc(arr) {
    let numbers = arr.filter((element)=>{
        return !isNaN(parseFloat(element))
    })
    let strings = arr.filter((element)=>{
        return isNaN(parseFloat(element))
    })
    numbers.sort(scientific_asc)
    strings.sort((a, b) => a.localeCompare(b));
    return [...numbers, ...strings];
}

export function scientific_asc(a, b) {
    let x, y;
    if (typeof a === "string" && typeof b === "string") {
        x = parseFloat(a.replace(" E", "E"));
        y = parseFloat(b.replace(" E", "E"));
    } else {
        if (a && b) {
            x = parseFloat(a);
            y = parseFloat(b);
        } else if (a) {
            return -1
        } else if (b) {
            return 1
        } else {
            return 0
        }
    }
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
}

export function scientific_desc(a, b) {
    let x, y;
    if (typeof a === "string" && typeof b === "string") {
        x = parseFloat(a.replace(" E", "E"));
        y = parseFloat(b.replace(" E", "E"));
    } else {
        if (a && b) {
            x = parseFloat(a);
            y = parseFloat(b);
        } else if (a) {
            return -1
        } else if (b) {
            return 1
        } else {
            return 0
        }
    }
    return ((x < y) ? 1 : ((x > y) ? -1 : 0));
}

export function euclidDistance(x1, y1, x2, y2) {
    return Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
}

export function getUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function classExists(className) {
    return document.getElementsByClassName(`${className}`).length > 0;
}

export function addZeroes(num) {
    // Convert input string to a number and store as a variable.
    let value = Number(num);
    // Split the input string into two arrays containing integers/decimals
    const res = num.split(".");
    // If there is no decimal point or only one decimal place found.
    if (res.length === 1 || res[1].length < 2) {
        // Set the number to two decimal places
        value = Number(value).toFixed(2);
    }
    // Return updated or original number.
    return Number(value);
}

/*
    * This function is used to convert a string to a float.
 */
export function convertToFloat(input) {

    if (typeof input === 'number') {
        return input;
    }
    if(input) {
        return parseFloat(input.replace(/ /g, '').replace(/E/g, 'e'));
    }
    return input;
}


export function setDecimalPlaces(data, fields, minimumFractionDigits = 2, maximumFractionDigits = 4) {
    for (const field of fields) {
        if (data[field] === null || data[field] === undefined || data[field] === "" || isNaN(data[field])) {
            if (field === 'pert_dose' || field === 'added_doses') {
                data[field] = data[field].toString().replace(/(\r\n|\n|\r)/gm, "|")
            }
        } else {
            const val = data[field];
            if (field === 'pert_dose' || field.split("_")[1]==="dose") {
                minimumFractionDigits = 1;
                maximumFractionDigits = 8;
            }
            data[field] = setDecimalPlace(val, minimumFractionDigits, maximumFractionDigits);
        }
    }
    return data
}

export function setDecimalPlace(val, minimumFractionDigits = 2, maximumFractionDigits = 4) {

    if (val === null || val === undefined || isNaN(val) || val === 0 || val === '0') {
        return val;
    } else if (Math.abs(val) > 10 ** 4 || Math.abs(val) < 10 ** (maximumFractionDigits * -1)) {
        return new Intl.NumberFormat('en-US', {
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits,
            notation: "scientific"
        }).format(val).replace("E", " E");
    } else {
        return new Intl.NumberFormat('en-US', {
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits,
            notation: "standard",
            useGrouping: false
        }).format(val);
    }
}

export function kde(kernel, thresholds, data) {
    return thresholds.map(t => [t, d3.mean(data, d => kernel(t - d))]);
}

// handles multi-select + filtering arrays
export function updateSelectedArray(array, element) {
    if (array.indexOf(element) !== -1) {
        array.splice(array.indexOf(element), 1)
    } else {
        array.push(element);
    }
    return array;
}
// only used in Single Compound pages. Will be deprecated
export function toggleLegend(domId, value) {
    let items = d3.select(`#${domId}`).selectAll(".tick");
    if (value !== "") {
        items.classed("inactive", false)
        items.filter(d => d !== value).classed("inactive", true)
    } else {
        items.classed("inactive", false)
    }
}

export async function savePNG(elementId, file_name, canvasDimension) {
    let canvas = null;
    if (canvasDimension) {
        canvas = await html2canvas(document.querySelector(elementId), canvasDimension);
    } else {
        canvas = await html2canvas(document.querySelector(elementId));
    }
    await savePNGCanvas(canvas, file_name);
}
export async function savePNGCanvas(canvas, file_name) {
    const FileSaver = require('file-saver');
    canvas.toBlob(function (blob) {
        FileSaver.saveAs(blob, file_name);
    }, "image/png");
}

/**
 *
 * @returns {any}
 */
export function dataTableCommonConfigs() {
    const data = {
        data: [],
        destroy: true,
        responsive: true,
        dom: 'Brtip',
        columns: [],
        pageLength: 15,
        lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, 'All'],
        ],
        orderMulti: true,
        autoWidth: true,
        searchable: true,
        search: {
            caseInsensitive: true,
            smart: true,
            autocomplete: true
        },
        orderCellsTop: true,
        // fixedHeader: true,
        buttons: [
            {
                title: "",
                extend: 'pdfHtml5',
                exportOptions: {
                    columns: ':visible'
                },
                orientation: 'landscape'
            },
            {
                extend: 'copyHtml5',
                title: "",
                exportOptions: {
                    columns: ':visible'
                }
            },
            {
                extend: 'csvHtml5',
                title: "",
                exportOptions: {
                    columns: ':visible'
                }
            },
            {
                extend: 'print',
                title: "",
                exportOptions: {
                    columns: ':visible'
                }
            }
        ]
    };
    return JSON.parse(JSON.stringify(data));
}

export function sortAlphaNum(a, b) {
    if (isNaN(a)) {
        if (isNaN(b)) {  // a and b are strings
            return a.localeCompare(b);
        } else {         // a string and b number
            return 1;  // a > b
        }
    } else {
        if (isNaN(b)) {  // a number and b string
            return -1;  // a < b
        } else {         // a and b are numbers
            return parseFloat(a) - parseFloat(b);
        }
    }
}
/**
 * constructs a regex string from an array
 * @param array
 * @returns {string}
 */
export function constructRegexStringFromArray(array) {
    return array.map(function (d) {
        let regex = '^';
        regex += `(?=.*(?<![^,])${escapeStringRegexp(d)}(?![^,]))`;
        regex += '.*$'
        return regex;
    })
}



/**
 * constructs a regex string from an array
 * @param array
 * @returns {string}
 */
export function constructLenientRegexStringFromArray(array) {
    return array.map(function (d) {
        let regex = '';
        regex += `${escapeStringRegexp(d)}`;
        regex += '.*$'
        return regex;
    })
}
/**
 * performs a column search on datatable based on a regex array and column index
 * @param columnRegexArray
 * @param columnIndex
 * @param  tableId
 */
export function regexSearchDataTableColumn(columnRegexArray, columnIndex, tableId) { // Add to table.js
    const dataTable = $(`#${tableId}`).DataTable();
    dataTable.column(+columnIndex).search(columnRegexArray.join("|"), true, false, true).draw()
}


/**
 * Get the index of the columns from the column list
 * @param columnList
 * @param columns
 * @returns {*[]}
 */
export function getIndexFromColumns(columnList, columns) {
    const index = [];
    for (let column of columns) {
        index.push(columnList.findIndex(d => d.data === column));
    }
    return index;
}

/**
 *
 * @param config
 * @returns {any}
 */
export function getDataTableConfig(config) {
    $.extend($.fn.dataTableExt.oSort, {
        "sci-not-string-pre": function (data) {
            return parseFloat(data.replace(/ /g, ''))
        },
        "dose-string-pre": function (data) {
            if (typeof (data) === "string") {
                let p;
                if (data.startsWith("log2.auc")) {
                    p = Number.POSITIVE_INFINITY
                } else if (data.startsWith("log2.ic50")) {
                    p = Number.MAX_VALUE
                } else {
                    p = parseFloat(data.replace(/ /g, ''))
                }
                return p;
            }
        }
    });
    const data = dataTableCommonConfigs();

    const mergedObject = {
        ...data,
        ...config.misc,
        ...{scrollX: true}
    };

    for (let button of mergedObject.buttons) {
        button.title = config.file_name;
        if (button.extend === 'pdfHtml5') {
            button.customize = function (doc) {
                doc.content.splice(1, 0, {
                    margin: [0, 0, 0, 12],
                    alignment: 'center',
                    image: getBase64Image(document.getElementById("prism_logo_secondary"))
                });
            }
        }
    }

    return mergedObject;
}

export function getBase64Image(img) {
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth * 0.5;
    canvas.height = img.naturalHeight * 0.5;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, img.naturalWidth * 0.25, img.naturalHeight * 0.25);
    return canvas.toDataURL("image/png");
}
// Only used in QC page with svg lattice layout. adjusts for plot location in grid for mouse over position event
export function getXYFromTranslate(element) {
    let split = element.getAttribute("transform").replace("translate", "").replace("(", "").replace(")", "").split(", ");
    let x = +split[0]
    let y = +split[1]
    return {x: x, y: y};
}

/**
 * Typical pass COMPOUND_OVERVIEW.getUnitsFromDose to this utility fucntion
 * @param doseUnits
 */
export function retrieveDoseUnits(doseUnits) {
    const dose_units = _.uniq(_.values(doseUnits));

    if (dose_units && dose_units.length > 0) {
        return dose_units[0]
    }
    return "uM";
}

// expects a sorted array of values and optional colorTheme
export function getCustomSequentialColorRange(domain, colorTheme) {
    let arr = domain.map((d, i) => i + 1) // turn strings into numbers

    if (arr.length <= 2) {
        arr = [...Array(4).keys()].map((d, i) => i + 1) // if only 2 doses, turn into 4 doses so that color scale colors are not so far apart
    }
    let step = 0; // old / not in use
    let values = [];
    let max = d3.max(arr) + step;
    let min = step;
    let scale;
    if (!colorTheme) {
        scale = d3.scaleSequential(d3.interpolateViridis).domain([max, min])
    } else if (colorTheme === "plasma") {
        scale = d3.scaleSequential(d3.interpolatePlasma).domain([max, min])
    } else if (colorTheme === "viridis") {
        scale = d3.scaleSequential(d3.interpolateViridis).domain([max, min])
    } else if (colorTheme === "inferno") {
        scale = d3.scaleSequential(d3.interpolateInferno).domain([max, min])
    }
    arr.forEach((d) => {
        values.push(scale(d + step)) // get list of evenly-spaced colors (light-dark)
    })
    return values
}

// returns values from data that are not in array. used to get values that are not in COMPOUND_OVERVIEW dose array
export function getValuesExcludedFromArray(array, data) {
    return data.filter(d => {
        if (!array.includes(d)) {
            return d
        }
    })
}

function getCPSAddedColors(array, colorTheme) {
    let colors = []
    let nest = d3.groups(array, d => d.split("|")[0])
    nest.forEach(d => {
        let local_colors = getCustomSequentialColorRange(d[1].reverse(), colorTheme)
        colors.push(local_colors)
    })
    return colors.flat()
}

export function getAddedColorsByScreenType(screen, array) { // depreciate?
    if (screen.type === "CPS") {
        return getCPSAddedColors(array, "plasma")
    } else {
        return getCustomSequentialColorRange(array, "plasma")
    }
}

export function sortAddedDosesByScreenType(screen, array) { // depreciate?
    if (screen.type === "CPS") {
        return array.sort(function (a, b) {
            return a.split("|")[0].localeCompare(b.split("|")[0]) || a.split("|")[1].split(" ")[1] - b.split("|")[1].split(" ")[1]
        })
    } else {
        return array.sort(function (a, b) {
            return d3.descending(a, b)
        })
    }
}

// depreciate!
// used in data parsers for setting expected attributes that update via user input
// not sure if this is useful bc it might vary by data or type (ie: brushed)
export function getSelectionAttributes() {
    return {
        selected: false,
        highlighted: true
    }
}

export function parseHTML(html) {
    const t = document.createElement('template');
    t.innerHTML = html;
    return t.content;
}

export const __emptyOnBottom = function (a, b, high) {
    a = a || high;
    b = b || high;
    // return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    return ((a > b) ? -1 : ((a < b) ? 1 : 0));
}
// used to add or remove objecvt from array based on attribute value
export function insertUniqueObject(arr, obj, attr) {
    if (attr === undefined) {
        attr = "id"
    }
    let isExist = arr.some(o => o[attr] === obj[attr]);
    if (!isExist) {
        arr.push(obj);
    } else {
        arr = arr.filter(o => o[attr] !== obj[attr])
    }
    return arr;
}

